export default __webpack_public_path__ + "static/media/satellite.0e176cc8.jpg";